import CustomerClient from "../kova/customerClient";
import {useEffect, useState} from "react";
import useCustomerClient from "./customerSource";


export function useFavorites(customerId: number|undefined) {

    const customerSource = useCustomerClient();
    const [favorites, setFavorites] = useState<Set<number>>(new Set<number>());

    async function doRefreshFavorites(stillUpdating: () => boolean) {
        if (customerId === undefined) return;
        const updatedFavorites = await customerSource.getFavorites(customerId);
        if (stillUpdating() === false) return;
        // this is stupid
        setFavorites((oldFavorites) => {
            const oldFavoritesJson = JSON.stringify(Array.from(oldFavorites).sort());
            const newFavoritesJson = JSON.stringify(Array.from(updatedFavorites).sort());
            if (oldFavoritesJson == newFavoritesJson) {
                return oldFavorites;
            }
            return new Set(updatedFavorites);
        });
    }

    useEffect(() => {

        let stillUpdating = true;
        doRefreshFavorites(() => stillUpdating);

        return () => { stillUpdating = false; }
    }, [customerId]);

    async function updateFavorites(updatedFavorites:Set<number>) {
        if (customerId === undefined) return;
        setFavorites(updatedFavorites);
        // Fire and forget
        await customerSource.updateFavorites(customerId, Array.from(updatedFavorites));

    }

    return { favorites, updateFavorites};
}
